import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Sidebar } from '../moderator/Sidebar';
import config from '../../config/config';

export function AnimalBookingForm() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const animalId = state?.id || state?.animal?.animal_no;
  const rem_share = parseInt(state?.animal?.remaining_shares) || 0;
  const [loading, setLoading] = useState(true);
  const [pricePerShare, setPricePerShare] = useState(0);

  const [formData, setFormData] = useState({
    shareholders: [{ firstName: '', lastName: '', isFisabilillah: false }],
    customer_name: '',
    phone: '',
    shares: '1',
    address: '',
    email: '',
    payment_method: 'Cash',
    bank_name: '',
    cheque_no: '',
    transaction_id: '',
    received_payment: 0,
    total_price: 0,
    remaining_balance: 0,
    animal_id: animalId || '',
    category: '',
    slaughtering_day: '',
    animal_no: '',
    type: ''
  });

  const fetchDetails = useCallback(async () => {
    if (!animalId) return;
    const category = state?.animal?.category || '';
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/hold/hold-booking/${animalId}?category=${encodeURIComponent(category)}`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      });

      if (response.ok) {
        const result = await response.json();
        const data = result.animal || result;
        const price = data.price_per_share || data.price || 0;
        setPricePerShare(price);

        setFormData(prev => ({
          ...prev,
          animal_id: data.id,
          category: data.category,
          slaughtering_day: data.slaughtering_day,
          type: data.type,
          animal_no: data.animal_no || data.animal_number,
          email: localStorage.getItem('userEmail') || '',
          total_price: price * parseInt(prev.shares),
          remaining_balance: (price * parseInt(prev.shares)) - (parseFloat(prev.received_payment) || 0),
          cat_id: data.cat_id,       // <--- Ye save karein
          subcat_id: data.subcat_id, // <--- Ye save karein
        }));
      }
    } catch (error) {
      console.error("Fetch Error:", error);
    } finally {
      setLoading(false);
    }
  }, [animalId]);

  useEffect(() => {
    if (!animalId) {
      alert("No Animal ID found!");
      navigate(-1);
      return;
    }
    fetchDetails();
  }, [animalId, navigate, fetchDetails]);
  // useEffect add karein taake total_price change hotay hi received_payment update ho jaye
  useEffect(() => {
    if (formData.total_price) {
      setFormData(prev => ({
        ...prev,
        received_payment: prev.total_price
      }));
    }
  }, [formData.total_price]);
  const handlePaymentInput = (val) => {
    const received = parseFloat(val) || 0;
    setFormData(prev => ({
      ...prev,
      received_payment: val,
      remaining_balance: prev.total_price - received
    }));
  };

  const handleShareChange = (num) => {
    const newCount = parseInt(num);
    const newTotal = newCount * pricePerShare;

    let updatedShareholders = [...formData.shareholders];
    if (newCount > updatedShareholders.length) {
      for (let i = updatedShareholders.length; i < newCount; i++) {
        updatedShareholders.push({ firstName: '', lastName: '', isFisabilillah: false });
      }
    } else {
      updatedShareholders = updatedShareholders.slice(0, newCount);
    }

    setFormData(prev => ({
      ...prev,
      shares: num,
      total_price: newTotal,
      remaining_balance: newTotal - (parseFloat(prev.received_payment) || 0),
      shareholders: updatedShareholders
    }));
  };

  const handleShareholderChange = (index, field, value) => {
    const updatedShareholders = [...formData.shareholders];
    updatedShareholders[index][field] = value;
    setFormData({ ...formData, shareholders: updatedShareholders });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const generatedCustomerId = `QRB${Math.floor(Math.random() * 100000)}`;
    const submissionDate = new Date().toLocaleString();
    const payload = {
      ...formData,
      customer_id: generatedCustomerId, // Backend isay receive karega
      booking_date: submissionDate,

    };
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/hold/share-booking`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        alert('Booking Confirmed Successfully!');
        navigate(`/moderator/booking/${generatedCustomerId}`, { state: { ...payload } });
      }
    } catch (error) {
      alert('Network error, please try again.');
    }
  };

  if (loading) return <div className="ml-64 p-8 text-center font-bold text-blue-600">Loading Data...</div>;

  const isLargeAnimal = ['cow', 'camel'].includes(formData.type?.toLowerCase());

  return (
    <>
      <div className="min-h-screen">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl overflow-hidden border border-gray-200">

          {/* Header */}
          <div className="bg-gradient-to-r from-blue-700 to-blue-900 p-6 text-white flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-black uppercase tracking-tight">Hold Animal Registration</h2>
              <p className="text-blue-100 text-xs mt-1">Fill in the customer and share details below</p>
            </div>
            <div className="text-right">
              <span className="bg-white/20 backdrop-blur-md px-4 py-2 rounded-lg font-mono font-bold text-lg">
                TAG: #{formData.animal_no}
              </span>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="p-8 space-y-8">

            {/* 1. Customer Information Section */}
            <section>
              <div className="flex items-center gap-2 mb-4 border-b pb-2">
                <div className="w-2 h-6 bg-blue-600 rounded-full"></div>
                <h3 className="font-black text-gray-700 uppercase text-sm tracking-widest">Customer Information</h3>
              </div>
              <div className="grid grid-cols-2 gap-5">
                <div className="col-span-2 md:col-span-1">
                  <label className="block text-[10px] font-bold mb-1 text-gray-500 uppercase">Customer Name</label>
                  <input required type="text" className="w-full border-2 border-gray-100 rounded-lg p-3 focus:border-blue-500 outline-none bg-gray-50/50 transition-all"
                    value={formData.customer_name} onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })} placeholder="Full Name" />
                </div>
                <div className="col-span-2 md:col-span-1">
                  <label className="block text-[10px] font-bold mb-1 text-gray-500 uppercase">Phone Number</label>
                  <input required type="text" className="w-full border-2 border-gray-100 rounded-lg p-3 focus:border-blue-500 outline-none bg-gray-50/50 transition-all"
                    value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} placeholder="03xx-xxxxxxx" />
                </div>
                <div className="col-span-2">
                  <label className="block text-[10px] font-bold mb-1 text-gray-500 uppercase">Address</label>
                  <input required type="text" className="w-full border-2 border-gray-100 rounded-lg p-3 focus:border-blue-500 outline-none bg-gray-50/50 transition-all"
                    value={formData.address} onChange={(e) => setFormData({ ...formData, address: e.target.value })} placeholder="Residential Address" />
                </div>
              </div>
            </section>

            {/* 2. Share Selection Section */}
            <section className="bg-blue-50/50 p-6 rounded-xl border border-blue-100">
              <div className="flex items-center justify-between">
                <div>
                  <label className="block text-sm font-black text-blue-900 uppercase">Select Number of Shares</label>
                  <p className="text-[10px] text-blue-600 font-bold">Price per share is automatically calculated</p>
                </div>
                <select className="w-48 border-2 border-blue-200 rounded-lg p-3 font-black text-blue-800 outline-none focus:border-blue-600 bg-white shadow-sm cursor-pointer"
                  value={formData.shares} onChange={(e) => handleShareChange(e.target.value)}>
                  {isLargeAnimal ? (
                    // ✅ Ab ye sirf bache hue shares (rem_share) tak options dikhayega
                    [...Array(rem_share)].map((_, i) => {
                      const num = i + 1;
                      return (
                        <option key={num} value={num}>
                          {num} {num === 1 ? 'Share' : 'Shares'}
                        </option>
                      );
                    })
                  ) : (
                    <option value="1">Full Animal (1 Share)</option>
                  )}
                </select>
              </div>
            </section>

            {/* 3. Shareholder Details Section */}
            <section className="space-y-6">
              <div className="flex items-center gap-2 mb-4 border-b pb-2">
                <div className="w-2 h-6 bg-blue-600 rounded-full"></div>
                <h3 className="font-black text-gray-700 uppercase text-sm tracking-widest">Shareholder Details</h3>
              </div>

              <div className="grid grid-cols-1 gap-6">
                {formData.shareholders.map((person, index) => (
                  <div key={index} className="p-6 border-2 border-gray-50 rounded-2xl bg-white shadow-sm hover:border-blue-100 transition-all">
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-[10px] font-black bg-blue-600 text-white px-3 py-1 rounded-full uppercase tracking-widest italic">Member {index + 1}</span>
                      <label className="flex items-center gap-2 cursor-pointer group">
                        <input type="checkbox" className="w-5 h-5 rounded-md border-gray-300 text-green-600 focus:ring-green-500 transition-all cursor-pointer"
                          checked={person.isFisabilillah} onChange={(e) => handleShareholderChange(index, 'isFisabilillah', e.target.checked)} />
                        <span className="text-xs font-black text-gray-500 group-hover:text-green-700 uppercase tracking-tighter">Fisabilillah Member</span>
                      </label>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <input placeholder="First Name"
                        className={`w-full border-2 border-gray-100 rounded-lg p-3 outline-none focus:border-blue-400 `}
                        value={person.firstName} onChange={(e) => handleShareholderChange(index, 'firstName', e.target.value)} />
                      <input placeholder="Last Name"
                        className={`w-full border-2 border-gray-100 rounded-lg p-3 outline-none focus:border-blue-400 `}
                        value={person.lastName} onChange={(e) => handleShareholderChange(index, 'lastName', e.target.value)} />
                    </div>

                    {/* Animal Spec Info (Sub-row) */}
                    <div className="grid grid-cols-3 gap-4 mt-5 pt-4 border-t border-gray-50">
                      <div className="bg-gray-50 p-2 rounded-lg text-center">
                        <label className="block text-[9px] font-black text-gray-400 uppercase">Type</label>
                        <p className="text-xs font-bold text-gray-700 capitalize">{formData.type}</p>
                      </div>
                      <div className="bg-gray-50 p-2 rounded-lg text-center">
                        <label className="block text-[9px] font-black text-gray-400 uppercase">Category</label>
                        <p className="text-xs font-bold text-gray-700 capitalize">{formData.category}</p>
                      </div>
                      <div className="bg-gray-50 p-2 rounded-lg text-center">
                        <label className="block text-[9px] font-black text-gray-400 uppercase">Sch. Day</label>
                        <p className="text-xs font-bold text-gray-700">Day {formData.slaughtering_day}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* 4. Payment Section (As requested at the bottom) */}
            <section className="bg-gray-50 p-6 rounded-2xl border-2 border-gray-100 shadow-inner">
              <div className="flex items-center gap-2 mb-6">
                <div className="w-2 h-6 bg-green-600 rounded-full"></div>
                <h3 className="font-black text-gray-700 uppercase text-sm tracking-widest">Payment & Billing</h3>
              </div>

              <div className="grid grid-cols-3 gap-4 mb-6">
                <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                  <label className="block text-[10px] font-black text-blue-600 uppercase mb-1">Total Payable</label>
                  <p className="text-xl font-black text-gray-800 tracking-tight">Rs. {formData.total_price}</p>
                </div>
                <div className="bg-white p-4 rounded-xl border border-green-200 shadow-sm">
                  <label className="block text-[10px] font-black text-green-600 uppercase mb-1 tracking-tighter">Amount Received</label>
                  <input required type="text" className="w-full text-xl font-black text-green-700 outline-none border-b-2 border-green-100 focus:border-green-500 p-0"
                    value={formData.received_payment} onChange={(e) => handlePaymentInput(e.target.value)} />
                </div>
                <div className={`p-4 rounded-xl border shadow-sm ${formData.remaining_balance > 0 ? 'bg-red-50 border-red-100' : 'bg-green-50 border-green-100'}`}>
                  <label className="block text-[10px] font-black text-gray-500 uppercase mb-1">Balance</label>
                  <p className={`text-xl font-black tracking-tight ${formData.remaining_balance > 0 ? 'text-red-600' : 'text-green-600'}`}>
                    Rs. {formData.remaining_balance}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6">
                <div className="col-span-2 md:col-span-1">
                  <label className="block text-[10px] font-black text-gray-500 uppercase mb-2">Payment Mode</label>
                  <div className="flex gap-2">
                    {['Cash', 'Cheque', 'Online'].map(mode => (
                      <button key={mode} type="button"
                        onClick={() => setFormData({ ...formData, payment_method: mode })}
                        className={`flex-1 py-3 px-2 rounded-lg text-xs font-black transition-all ${formData.payment_method === mode ? 'bg-blue-600 text-white shadow-md scale-105' : 'bg-white text-gray-500 border border-gray-200 hover:bg-gray-100'}`}>
                        {mode}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="col-span-2 md:col-span-1">
                  {formData.payment_method === 'Cheque' && (
                    <div className="grid grid-cols-2 gap-3 animate-in fade-in slide-in-from-top-2">
                      <div>
                        <label className="block text-[10px] font-black text-blue-600 uppercase mb-1">Bank</label>
                        <input required className="w-full border-2 border-blue-100 rounded-lg p-2.5 text-sm font-bold outline-none focus:border-blue-500" placeholder="HBL/UBL"
                          value={formData.bank_name} onChange={(e) => setFormData({ ...formData, bank_name: e.target.value })} />
                      </div>
                      <div>
                        <label className="block text-[10px] font-black text-blue-600 uppercase mb-1">Cheque #</label>
                        <input required className="w-full border-2 border-blue-100 rounded-lg p-2.5 text-sm font-bold outline-none focus:border-blue-500" placeholder="00123..."
                          value={formData.cheque_no} onChange={(e) => setFormData({ ...formData, cheque_no: e.target.value })} />
                      </div>
                    </div>
                  )}

                  {formData.payment_method === 'Online' && (
                    <div className="animate-in fade-in slide-in-from-top-2">
                      <label className="block text-[10px] font-black text-blue-600 uppercase mb-1">Transaction ID (TID)</label>
                      <input required className="w-full border-2 border-blue-100 rounded-lg p-2.5 text-sm font-mono font-bold outline-none focus:border-blue-500" placeholder="Enter TID Number"
                        value={formData.transaction_id} onChange={(e) => setFormData({ ...formData, transaction_id: e.target.value })} />
                    </div>
                  )}
                </div>
              </div>
            </section>

            {/* Footer Button */}
            <div className="pt-1">
              <button type="submit" className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white py-3 rounded-2xl font-black text-xl hover:from-blue-700 hover:to-blue-800  transform active:scale-[0.98] transition-all uppercase tracking-widest">
                Confirm & Register Booking
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}